import { HomeFloorNegative1Icon } from './HomeFloorNegative1Icon';

/**
 * author: Michael Irigoyen
 * id 8809DA4E-CB12-48C9-AA91-8E377701862F
 * name home-floor-negative-1
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-negative-1.svg
 * tags
 * - Home Automation 
 */
export const HouseFloorMinus1Icon = HomeFloorNegative1Icon;
export default HouseFloorMinus1Icon